export const initialise = () => {
    if (!document.body.classList.contains('page-job-details')) return
    const stickyApply = document.querySelector<HTMLElement>('.component-sticky-apply')
    if (!stickyApply) return

    createStickyApplyHeading(stickyApply)
    showStickyApply(stickyApply)
}

export const createStickyApplyHeading = (stickyApply: HTMLElement) => {
    const jobTitle = document.querySelector<HTMLElement>('.title-widget .header__text')
    const stickyHeading = stickyApply.querySelector<HTMLElement>('.component-sticky-apply__heading')

    if (!jobTitle || !stickyHeading) return

    stickyHeading.innerText = jobTitle.innerText
}

export const showStickyApply = (stickyApply: HTMLElement) => {
    const hero = document.querySelector<HTMLElement>('.page-job-details__container-hero')
    if (!hero) return

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                stickyApply.classList.add('component-sticky-apply--visible')
            } else {
                stickyApply.classList.remove('component-sticky-apply--visible')
            }
        }, { threshold: 0 }
    )

    observer.observe(hero)
}
